import type { Nullable } from "@/types";

import { isNil } from "@/utilities/data";

export const isValidNumber = (value?: unknown): value is number => {
  return typeof value === "number" && !isNaN(value);
};

/**
 * In JavaScript, division by zero is an undefined operation.
 * When you divide zero by zero (0 / 0), the result is NaN (Not-a-Number).
 * This happens because division by zero has no mathematical meaning,
 * and JavaScript uses NaN to indicate an undefined or invalid arithmetic operation.
 */
export const safeDivide = (numerator: number, denominator: number): number => {
  if (denominator === 0) return 0;

  return numerator / denominator;
};

export const getIntValue = (value: number | string, fallbackValue?: number) => {
  const stringValue = typeof value === "number" ? `${value}` : value;
  const intValue = parseInt(stringValue, 10);
  return isNaN(intValue) ? fallbackValue : intValue;
};

export const isEqualNumber = (a?: Nullable<number>, b?: Nullable<number>) => {
  if (isNil(a) && isNil(b)) return true;
  return a === b;
};
